const SESSION_COLORS = [
  'purple',
  'magenta',
  'teal',
  'warning',
  'primary',
  'success',
  'failure',
  'olive',
] as const;

const hashString = (s: string) =>
  [...s].reduce((acc, c) => c.charCodeAt(0) + ((acc << 5) - acc), 0);

const getSessionColorIndex = (memberId: string) =>
  Math.abs(hashString(memberId)) % SESSION_COLORS.length;

const getSessionColorName = (memberId: string) =>
  SESSION_COLORS[getSessionColorIndex(memberId)];

export {
  SESSION_COLORS,
  hashString,
  getSessionColorIndex,
  getSessionColorName,
};
